import { useState, useEffect } from 'react';

function getDimensions(target) {
    if (target instanceof HTMLElement) {
        return target.getBoundingClientRect();
    }
    if (target === null) {
        return {};
    }
    return {
        width: target.innerWidth,
        height: target.innerHeight
    };
}
/**
 * This hook is used to retrieve the dimensions of the window or element provided.
 */
function useDimensions(element) {
    var _a, _b;
    const [dimensions, setDimensions] = useState(getDimensions(element === undefined ? window : (_b = (_a = element.ref) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null));
    useEffect(() => {
        var _a, _b;
        let isMounted = true;
        const target = element === undefined ? window : (_b = (_a = element.ref) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null;
        function handleResize() {
            if (isMounted)
                setDimensions(getDimensions(target));
        }
        let resizeObserver = null;
        if (target instanceof HTMLElement) {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(target);
        }
        else if (element === undefined) {
            window.addEventListener('resize', handleResize);
        }
        return () => {
            isMounted = false;
            if (element === undefined) {
                window.removeEventListener('resize', handleResize);
            }
            else if (target) {
                resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
            }
        };
    }, []);
    return dimensions;
}

export { useDimensions };
//# sourceMappingURL=useDimensions.esm.js.map
